'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contact = void 0;
const Func = require("../../func");
const $ = require("jquery");
class Contact {
    constructor(
    // 空白チェック項目
    notNullKeys = [
        'your_name',
        'your_name_kana',
        'your_email',
        'your_type',
        'your_detail',
    ]) {
        this.notNullKeys = notNullKeys;
        $('.trigContactAccept').on('click', () => {
            $('.bulletContactErrorMessage').hide();
            const values = this.getValues();
            return this.validates(values);
        });
    }
    getValues() {
        return {
            your_name: $('.paramContactValue[data-name="your_name"]').val(),
            your_name_kana: $('.paramContactValue[data-name="your_name_kana"]').val(),
            your_email: $('.paramContactValue[data-name="your_email"]').val(),
            your_type: $('.paramContactValue[data-name="your_type"]').val(),
            your_detail: $('.paramContactValue[data-name="your_detail"]').val(),
        };
    }
    validates(values) {
        let errorName = '';
        // 空白チェック
        this.notNullKeys.forEach(function (v) {
            if (Func.isNull(values[v])) {
                $('.bulletContactErrorMessage[data-name="' + v + '"]').show();
                if (!errorName) {
                    errorName = v;
                }
            }
        });
        // メールフォーマット
        if (!Func.isNull(values.email) && !Func.matchEmailFormat(values.email)) {
            $('.bulletContactErrorMessage[data-name="email_not_matched"]').show();
            if (!errorName) {
                errorName = 'your_mail';
            }
        }
        // 電話番号フォーマット
        if (!Func.isNull(values.tel) && !Func.matchTelFormat(values.tel)) {
            $('.bulletContactErrorMessage[data-name="tel_not_matched"]').show();
            if (!errorName) {
                errorName = 'your_tel';
            }
        }
        //エラー時処理
        if (errorName) {
            this.scrollToError(errorName);
            $('.bulletContactErrorText').show();
            return false;
        }
    }
    scrollToError(errorName) {
        const formPosition = $('.bulletContactError[data-name="' + errorName + '"]').offset().top;
        const headerHeight = $('.paramHeader').outerHeight() || 0;
        $('html, body').animate({
            scrollTop: formPosition - headerHeight
        }, 'slow');
    }
}
exports.Contact = Contact;
exports.default = Contact;
